import React from 'react'

export default function TopTitleBar({ title, rightBtn, rightAction, isChild, children }) {
  return (
    <div className='topTitleBar'>
      <div className="topTitleBarTextContainer">
        {isChild ? <>
          {children}
        </> : <>
          <h2 className="topTitleBarText">{title}</h2>
          {rightBtn ? <button onClick={rightAction} className='btn btn-primary'>{rightBtn}</button> : null}
        </>}

      </div>
    </div>
  )
}
